import { parseUtcDate } from '../backend/time.mjs';

// Compteur des actions (POST) en cours : alimente la barre de chargement en haut de l'écran.
let pending = 0;
const listeners = new Set();
const notify = () => listeners.forEach((l) => l(pending));
export const onBusy = (l) => { listeners.add(l); return () => listeners.delete(l); };

export async function api(path, body) {
  const action = body !== undefined;
  if (action) { pending += 1; notify(); }
  try {
    const res = await fetch(`/api${path}`, {
      method: action ? 'POST' : 'GET',
      headers: action ? { 'Content-Type': 'application/json' } : {},
      body: action ? JSON.stringify(body) : undefined,
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.error || `Erreur ${res.status}`);
    return data;
  } finally {
    if (action) { pending -= 1; notify(); }
  }
}

export const fmt = (n) => `${new Intl.NumberFormat('fr-FR').format(n)} CDF`;
export const fdate = (iso) =>
  iso ? parseUtcDate(iso).toLocaleString('fr-FR', { dateStyle: 'short', timeStyle: 'short', timeZone: 'Africa/Kinshasa' }) : '';

export const STATUS_FR = {
  Scheduled: 'À venir', LIVE: 'En cours', FT: 'Terminé', AET: 'Terminé (prol.)',
  PENS: 'Terminé (t.a.b.)', Cancelled: 'Annulé', Postponed: 'Reporté', Suspended: 'Suspendu',
};

export function toggleTheme() {
  const t = document.documentElement.dataset.theme === 'dark' ? 'light' : 'dark';
  document.documentElement.dataset.theme = t;
  localStorage.setItem('bf_theme', t);
}
